import { render, staticRenderFns } from "./Step_8.vue?vue&type=template&id=42c805a2&"
import script from "./Step_8.vue?vue&type=script&lang=js&"
export * from "./Step_8.vue?vue&type=script&lang=js&"
import style0 from "./Step_8.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports